import { Eye, ShoppingCart, Star } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import { formatRupiah } from '../utils/format';
export default function ProductCard({product}){
  const {addItem}=useCart();
  return <article className="product-card" data-testid="product-card">
    <Link className="product-image-link" to={`/products/${product._id}`}>
      <img className="product-image" src={product.imageUrl} alt={`Gambar ${product.name}`} loading="lazy" onError={(e)=>{e.currentTarget.src='/images/placeholder.svg';}}/>
      <span className="category-badge">{product.category}</span>
    </Link>
    <div className="product-body"><div className="product-meta"><span><Star size={15} fill="currentColor"/> {product.rating}</span><span>Terjual {product.sold}</span></div>
      <Link to={`/products/${product._id}`} className="product-title">{product.name}</Link>
      <p className="product-description">{product.description}</p><div className="seller-row"><span>Penjual: {product.seller}</span><span className={product.stock>0?'stock in':'stock out'}>Stok {product.stock}</span></div>
      <div className="product-footer"><strong>{formatRupiah(product.price)}</strong><div className="product-buttons"><Link className="icon-button" to={`/products/${product._id}`} aria-label="Detail"><Eye size={18}/></Link><button data-testid="add-to-cart" className="btn primary compact" disabled={product.stock<1} onClick={()=>addItem(product)}><ShoppingCart size={17}/>Tambah</button></div></div>
    </div>
  </article>;
}
